import type * as ContractTypes from '@draftkings/dk-data-layer';

export function isEventStarted(event: ContractTypes.SportEvent): boolean {
    return event.status.toLowerCase() === 'started';
}
